import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMapPointer16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMapPointer16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.5 6.385c0 1.566-.833 3.518-1.946 5.133-.547.793-1.127 1.454-1.643 1.906a3.7 3.7 0 0 1-.66.477 1 1 0 0 1-.237.098 1 1 0 0 1-.24-.098 3.8 3.8 0 0 1-.663-.479c-.519-.451-1.103-1.113-1.653-1.906C4.338 9.9 3.5 7.949 3.5 6.385 3.5 3.985 5.498 2 8.014 2 10.523 2 12.5 3.979 12.5 6.385m1 0C13.5 10.1 9.668 15 8.014 15S2.5 10.1 2.5 6.385C2.5 3.41 4.969 1 8.014 1S13.5 3.41 13.5 6.385M9.25 6.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m1 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMapPointer16);
